import React from 'react';
import {Link} from "react-router-dom";

const NavLink = ({href, text, listClass, linkClass, target = '_self'}) => {
    return (
        <li className={`${listClass ? listClass : 'sl-font sl-font-medium sl-text-sm'}`}>
            <Link className={`${linkClass ? linkClass : 'sl-text-gray-base sl-no-underline'}`} to={href}
                  target={target}
                  rel="noreferrer"
            >
                {text}
            </Link>
        </li>
    );
};

export default NavLink;
